import { render, staticRenderFns } from "./NavChild.vue?vue&type=template&id=7e8de158&scoped=true&"
import script from "./NavChild.vue?vue&type=script&lang=ts&"
export * from "./NavChild.vue?vue&type=script&lang=ts&"
import style0 from "./NavChild.vue?vue&type=style&index=0&id=7e8de158&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8de158",
  null
  
)

export default component.exports